import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

// Register a new incubator
export const registerIncubator = async (incubatorData) => {
  try {
    const token = localStorage.getItem('token');
    // Don't set Content-Type manually — axios sets it automatically for
    // FormData with the correct multipart boundary.
    const config = {
      headers: {
        'x-auth-token': token,
      },
    };
    const response = await axios.post(`${API_URL}/api/incubators`, incubatorData, config);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get incubator profile
export const getIncubatorProfile = async (incubatorId) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'x-auth-token': token,
      },
    };
    const response = await axios.get(`${API_URL}/api/incubator/${incubatorId}`, config);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update incubator profile
export const updateIncubatorProfile = async (incubatorId, incubatorData) => {
  try {
    const token = localStorage.getItem('token');
    // Don't set Content-Type manually — axios sets it automatically,
    // correctly, for both FormData (multipart with boundary) and plain
    // objects (application/json).
    const config = {
      headers: {
        'x-auth-token': token,
      },
    };
    const response = await axios.put(`${API_URL}/api/incubator/${incubatorId}`, incubatorData, config);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export default {
  registerIncubator,
  getIncubatorProfile,
  updateIncubatorProfile,
};
